export default "__VITE_ASSET__C2ktzmk9__"